'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _query = require('utilities/query');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserIngredientsService = function () {
  function UserIngredientsService($http) {
    'ngInject';

    _classCallCheck(this, UserIngredientsService);

    this.$http = $http;
  }

  _createClass(UserIngredientsService, [{
    key: 'getDefaultQuery',
    value: function getDefaultQuery() {
      return _extends({}, (0, _query.getQuery)(), {
        orderBy: 'UserIngredientName',
        direction: 'asc'
      });
    }
  }, {
    key: 'add',
    value: function add(ingredient) {
      return this.$http.post('/api/user_ingredient', ingredient);
    }
  }, {
    key: 'delete',
    value: function _delete(id) {
      return this.$http.delete('/api/user_ingredient/' + id);
    }
  }, {
    key: 'update',
    value: function update(ingredient) {
      return this.$http.put('/api/user_ingredient/' + ingredient.UserIngredientId, ingredient);
    }
  }, {
    key: 'search',
    value: function search(query) {
      return this.$http.get('/odata/UserIngredientOData', {
        params: _extends({
          $select: 'UserIngredientId, UserIngredientName, ProductCount',
          $top: query.take,
          $skip: query.calculateSkip(),
          $orderby: query.orderBy + ' ' + query.direction
        }, query.filter && { $filter: query.filter.toString() }, {
          $count: true
        })
      });
    }
  }, {
    key: 'isUniqueIngredientName',
    value: function isUniqueIngredientName(ingredientName, id) {
      return this.$http.get('/api/user_ingredient/unique_ingredient_name', {
        params: {
          UserIngredientName: ingredientName,
          id: id
        }
      });
    }
  }]);

  return UserIngredientsService;
}();

exports.default = UserIngredientsService;


// WEBPACK FOOTER //
// ./components/app/admin/user-ingredients/user-ingredients.service.js